// Contadores das abas do hub de Conteúdo (badges). Só `count: exact, head`
// — nenhuma linha trafega. Invalidado pelos hooks de blog/categorias; os
// demais domínios (depoimentos, projetos, catálogo, links) revalidam pelo
// staleTime curto.
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

type CountQuery = ReturnType<ReturnType<typeof supabase.from>["select"]>;

async function countRows(table: string, refine?: (q: CountQuery) => CountQuery) {
  let q = supabase
    .from(table as never)
    .select("id", { count: "exact", head: true }) as unknown as CountQuery;
  if (refine) q = refine(q);
  const { count, error } = await q;
  if (error) throw error;
  return count ?? 0;
}

export interface ContentCounts {
  blog: number;
  depoimentos: number;
  produtos: number;
  catalogo: number;
  links: number;
  categorias: number;
}

export function useContentCounts() {
  return useQuery({
    queryKey: ["content-hub-counts"],
    queryFn: async (): Promise<ContentCounts> => {
      const [blog, depoimentos, produtos, catalogo, links, categorias] = await Promise.all([
        countRows("blog_posts"),
        countRows("testimonials"),
        countRows("projects"),
        countRows("products_catalog"),
        countRows("bio_links", (q) => q.is("deleted_at", null) as unknown as CountQuery),
        countRows("blog_categories"),
      ]);
      return { blog, depoimentos, produtos, catalogo, links, categorias };
    },
    staleTime: 30_000,
  });
}
